module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btn-label":"Read More"},"ar":{"btn-label":"اقرأ المزيد"}}')
  delete Component.options._Ctor
}
